import { ColumnDef } from '@tanstack/react-table'
import { Clinic } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'

export const columns: ColumnDef<Clinic>[] = [
  {
    accessorKey: 'clinic_name',
    header: '診所名稱',
  },
  {
    accessorKey: 'area',
    header: '區域',
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const isActive = row.getValue('is_active')
      return (
        <Badge variant={isActive ? 'default' : 'secondary'}>{isActive ? '啟用中' : '停用'}</Badge>
      )
    },
  },
  {
    accessorKey: 'broadcast_devices',
    header: '廣播裝置',
    cell: ({ row }) => {
      const devices = row.original.broadcast_devices || []
      return (
        <div className="flex items-center">
          <Badge variant="outline" className="mr-2">
            {devices.length}
          </Badge>
        </div>
      )
    },
  },
]
